const defaults = {
    account: 'default.accountPage',
    asset: 'default.assetPage',
    category: 'default.categoryPage',
    checkout: 'default.checkoutPage',
    class: 'default.classPage',
    confirm: 'default.confirmPage',
    course: 'default.coursePage',
    document: 'default.documentPage',
    home: 'default.homePage',
    instructor: 'default.instructorDetail',
    learningBoard: 'default.learningBoardPage',
    meeting: 'default.meetingPage',
    member: 'default.memberPage',
    membership: 'default.membershipPage',
    memberships: 'default.membershipLandingPage',
    microcast: 'default.microcastPage',
    myLearnings: 'default.myLearningsPage',
    myMeetings: 'default.myMeetingsPage',
    program: 'default.programPage',
    search: 'default.searchPage',
    hubDocuments: 'default.hubDocumentsPage',
    hubDashboard: 'default.hubDashboardPage',
    hubLearnings: 'default.hubLearningsPage',
    hubMeetings: 'default.hubMeetingsPage',
};
const configs = {
    'default.mainLayout': {
        type: 'template',
        name: 'Main Layout',
        component: 'RowLayout',
        props: {
            items: ['ml.appbar', 'ml.catnav', 'template.ml.mainContent', 'ml.footer'],
        },
    },
    'default.fullPageLayout': {
        type: 'template',
        subType: 'template',
        name: 'Full Page Layout',
        component: 'FullPageLayout',
        props: {
            items: ['ml.appbar', 'template.ml.mainContent', 'ml.footer'],
        },
    },
    'ml.appbar': {
        type: 'component',
        component: 'AppBar',
        props: {
            limitToPageWidth: true,
            searchAction: '@searchAction',
            rootCategory: '@rootCategory',
            showSubCategoryDropdowns: true,
            showLogo: true,
        },
    },
    'ml.catnav': {
        type: 'component',
        component: 'CategoryNav',
        props: {
            limitToPageWidth: true,
            rootCategory: '@rootCategory',
            showSubCategoryDropdowns: true,
        },
    },
    'template.ml.mainContent': {
        type: 'component',
        component: 'HtmlWidget',
        props: {
            text: '<h2>Main Content Slot</h2>',
        },
    },
    'ml.footer': {
        type: 'component',
        component: 'FooterBar',
        props: {
            limitToPageWidth: true,
        },
    },
    'ml.footerColumns': {
        component: 'ColumnLayout',
        props: {
            columns: [
                {
                    id: 'col1',
                    config: 'footerColumn1',
                    md: 3,
                    xs: 12,
                },
                {
                    id: 'col2',
                    config: 'footerColumn2',
                    md: 3,
                    xs: 12,
                },
                {
                    id: 'col3',
                    config: 'footerColumn3',
                    md: 3,
                    xs: 12,
                },
                {
                    id: 'col4',
                    config: 'footerColumn4',
                    md: 3,
                    xs: 12,
                },
            ],
            layout: {
                padding: {
                    top: '050',
                },
            },
            limitToPageWidth: true,
            spacing: 2,
        },
        type: 'component',
    },
    footerColumn1: {
        component: 'LinksWidget',
        props: {
            link: {
                links: [
                    {
                        id: 'test-link',
                        course: '',
                        label: 'Example Link',
                        type: 'url',
                        url: 'https://microcasting.com',
                    },
                ],
                title: 'Link 1',
            },
        },
        type: 'component',
    },
    footerColumn2: {
        component: 'LinksWidget',
        props: {
            link: {
                links: [
                    {
                        id: 'test-link',
                        course: '',
                        label: 'Example Link',
                        type: 'url',
                        url: 'https://microcasting.com',
                    },
                ],
                title: 'Link 2',
            },
        },
        type: 'component',
    },
    footerColumn3: {
        component: 'LinksWidget',
        props: {
            link: {
                links: [
                    {
                        id: 'test-link',
                        course: '',
                        label: 'Example Link',
                        type: 'url',
                        url: 'https://microcasting.com',
                    },
                ],
                title: 'Link 3',
            },
        },
        type: 'component',
    },
    footerColumn4: {
        component: 'SocialLinksWidget',
        props: {
            link: {
                links: [
                    {
                        id: '011666e0-c0e2-4811-9f09-791142fca473',
                        platform: 'Facebook',
                        url: 'https://facebook.com',
                    },
                    {
                        id: 'd7c2aea3-7225-4886-84e5-a52ed97b1d16',
                        platform: 'Instagram',
                        url: 'https://instagram',
                    },
                    {
                        id: 'cbe54543-64e0-4085-bcb2-32d1eeeef328',
                        platform: 'X',
                        url: 'https://X.com',
                    },
                ],
                title: 'Connect With Us',
            },
        },
        type: 'component',
    },
    'wln.leftContent': {
        type: 'component',
        component: 'HtmlWidget',
        props: {
            text: '<h2>Default Left Nav Content</h2>',
        },
    },
    'wln.rightContent': {
        type: 'component',
        component: 'HtmlWidget',
        props: {
            text: '<h2>Default Right Content</h2>',
        },
    },
    'wln.mc': {
        type: 'component',
        component: 'ColumnLayout',
        props: {
            spacing: 2,
            limitToPageWidth: true,
            columns: [
                {
                    id: 'left',
                    xs: 12,
                    md: 3,
                    config: 'wln.leftContent',
                },
                {
                    id: 'right',
                    xs: 12,
                    md: 9,
                    config: 'wln.rightContent',
                },
            ],
        },
    },
    'default.withLeftNavLayout': {
        type: 'template',
        name: 'Left Nav Layout',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'wln.mc',
        },
    },
    'hp.mc.1': {
        component: 'HeaderWidget',
        props: {
            backgroundImage: {
                assetId: undefined,
            },
            horizontalAlignment: 'left',
            limitToPageWidth: true,
            margin: {
                bottom: 0,
                enabled: true,
                left: 0,
                right: 0,
                top: 0,
            },
            opacity: '1',
            padding: {
                bottom: 0,
                enabled: true,
                left: 0,
                right: 0,
                top: 0,
            },
            content: {
                html: null,
                slate: [
                    {
                        children: [
                            {
                                bold: true,
                                fontSize: 30,
                                text: 'Enter Headline/Image Here',
                            },
                        ],
                        type: 'p',
                    },
                ],
            },
            verticalAlignment: 'middle',
        },
        type: 'component',
    },
    'hp.mc.2.1': {
        component: 'RichTextWidget',
        props: {
            content: {
                html: null,
                slate: [
                    {
                        id: '03gr9',
                        align: 'center',
                        children: [
                            {
                                bold: true,
                                text: 'Enter Opening Statement Here',
                            },
                        ],
                        type: 'p',
                    },
                ],
            },
            layout: {
                padding: {
                    bottom: '30',
                    right: '',
                    top: '30',
                },
            },
        },
        type: 'component',
    },
    'hp.mc.2.2': {
        component: 'FeaturedCard',
        props: {
            item: {},
            layout: {
                padding: {
                    bottom: '20',
                    top: '20',
                },
            },
            settings: {
                showCourseHeadline: true,
                showCourseInfo: true,
                showInstructor: true,
                showOfferedBy: true,
            },
        },
        type: 'component',
    },
    'hp.mc.2.3': {
        component: 'ItemCarousel',
        props: {
            category: '@categoryId',
            layout: {
                padding: {
                    bottom: '020',
                    top: '20',
                },
            },
            maxItemCount: 20,
            showTitle: true,
            text: {
                html: '<div>&nbsp;</div>',
            },
        },
        type: 'component',
    },
    'hp.mc.2.4': {
        component: 'ItemCarousel',
        props: {
            category: '@categoryId',
            layout: {
                padding: {
                    bottom: '20',
                    top: '20',
                },
            },
            maxItemCount: 20,
            showTitle: true,
            text: {
                html: '<div>&nbsp;</div>',
            },
        },
        type: 'component',
    },
    'hp.mc.2.5': {
        component: 'ItemCarousel',
        props: {
            category: '@categoryId',
            layout: {
                padding: {
                    bottom: '20',
                    top: '20',
                },
            },
            maxItemCount: 20,
            showTitle: true,
            text: {
                html: '<div>&nbsp;</div>',
            },
        },
        type: 'component',
    },
    'hp.mc.2': {
        component: 'RowLayout',
        editProps: {
            canAdd: true,
            canRemove: true,
        },
        props: {
            backgroundColor: '#00ff00',
            horizontalPadding: 1,
            items: [
                'hp.mc.2.1',
                'hp.mc.2.2',
                'hp.mc.2.3',
                'hp.mc.2.4',
                'hp.mc.2.5',
            ],
            limitToPageWidth: true,
            verticalPadding: 1,
        },
        type: 'component',
    },
    'hp.mc': {
        type: 'component',
        component: 'RowLayout',
        props: {
            backgroundColor: '#00ff00',
            horizontalPadding: 1,
            items: [
                'hp.mc.1',
                'hp.mc.2',
            ],
            limitToPageWidth: false,
            verticalPadding: 1,
        },
    },
    'default.homePage': {
        type: 'template',
        extends: 'default.mainLayout',
        component: '',
        name: 'Default Home Page',
        overrides: {
            'template.ml.mainContent': 'hp.mc',
        },
    },
    'cp.rc.1': {
        type: 'component',
        component: 'HtmlWidget',
        props: {
            title: 'Marketing Zone',
        },
    },
    'cp.rc.2': {
        type: 'component',
        component: 'FeaturedCard',
        props: {
            featuredCard: '@featuredCard',
            enrollAction: '@enrollAction',
        },
    },
    'cp.rc.3': {
        type: 'component',
        component: 'ItemList',
        props: {
            categoryId: '@categoryId',
            viewAction: '@viewItemAction',
            settings: {},
        },
    },
    'cp.rc.4': {
        type: 'component',
        component: 'RecommendedCourses',
        props: {
            courses: '@courses',
        },
    },
    'cp.mc.1': {
        component: 'HeaderWidget',
        props: {
            backgroundImage: {},
            horizontalAlignment: 'left',
            layout: {
                padding: {
                    bottom: '20',
                },
            },
            limitToPageWidth: true,
            margin: {
                bottom: 0,
                enabled: true,
                left: 0,
                right: 0,
                top: 0,
            },
            opacity: '1',
            padding: {
                bottom: 0,
                enabled: true,
                left: 0,
                right: 0,
                top: 0,
            },
            content: {
                html: null,
                slate: [
                    {
                        children: [
                            {
                                bold: true,
                                fontSize: 36,
                                text: 'Enter Category Name ',
                            },
                        ],
                        type: 'p',
                    },
                    {
                        id: 'wv9ws',
                        children: [
                            {
                                fontSize: 26,
                                text: 'Compelling Message',
                            },
                        ],
                        type: 'p',
                    },
                ],
            },
            verticalAlignment: 'middle',
        },
        type: 'component',
    },
    'cp.mc.2': {
        component: 'FeaturedCard',
        props: {
            item: {},
            layout: {
                padding: {
                    bottom: '20',
                    top: '020',
                },
            },
            settings: {
                showCourseHeadline: true,
                showCourseInfo: true,
                showInstructor: true,
                showOfferedBy: true,
            },
        },
        type: 'component',
    },
    'cp.mc.3': {
        component: 'ItemList',
        props: {
            categoryId: '@categoryId',
            layout: {
                padding: {
                    bottom: '20',
                    top: '20',
                },
            },
            settings: {
                defaultItemView: 'list',
                ItemCount: 40,
                showTitle: true,
                showToggleViewBtns: true,
            },
            text: {
                html: null,
                slate: [
                    {
                        children: [
                            {
                                text: 'Enter Listing Name',
                            },
                        ],
                        type: 'p',
                    },
                ],
            },
            viewAction: '@viewItemAction',
        },
        type: 'component',
    },
    'cp.mc': {
        component: 'RowLayout',
        editProps: {
            canAdd: true,
            canRemove: true,
        },
        props: {
            backgroundColor: '#00ff00',
            horizontalPadding: 1,
            items: [
                'cp.mc.1',
                'cp.mc.2',
                'cp.mc.3',
            ],
            limitToPageWidth: true,
            verticalPadding: 1,
        },
        type: 'component',
    },
    'default.categoryPage': {
        type: 'template',
        component: '',
        name: 'Default Category Page',
        extends: 'template.categoryPage',
        overrides: {
            'template.ml.mainContent': 'cp.mc',
        },
    },
    'crp.mc.1': {
        type: 'component',
        component: 'CourseSummary',
        props: {
            courseID: '@courseID',
            handleEnroll: '@enrollAction',
            settings: {
                showPrice: false,
                showShareBtns: false,
                showVideo: true,
                showRatings: false,
                showCourseInfo: true,
                showCourseHeadline: true,
                showOrderBy: true,
                showInstructor: true,
                showEnrollButton: true,
                showCourseDesc: true,
                showActionButton: true,
                showPriceButton: true,
            },
        },
    },
    'crp.mc.tabs.1': {
        type: 'component',
        component: 'About',
        props: {
            course: '@courseID',
            enrollAction: '@enrollAction',
        },
    },
    'crp.mc.tabs.2': {
        type: 'component',
        component: 'Instructors',
        props: {
            instructors: '@course.instructors',
        },
    },
    'crp.mc.tabs.3': {
        type: 'component',
        component: 'Syllabus',
        props: {
            sections: '@course.sections',
            item: '@course',
            titleTokenKey: 'courseOutlineLabel',
            title: 'Course Outline',
        },
    },
    'crp.mc.tabs.4': {
        type: 'component',
        component: 'Reviews',
        props: {
            reviews: '@course.reviews',
        },
    },
    'crp.mc.tabs.5': {
        type: 'component',
        component: 'FAQs',
        props: {
            faqs: '@course.faqs',
        },
    },
    'crp.mc.tabs': {
        type: 'component',
        component: 'CourseTabs',
        props: {
            courseID: '@courseID',
            tabSettings: [
                {
                    key: 'about',
                    active: true,
                },
                {
                    key: 'instructors',
                    active: true,
                },
                {
                    key: 'outline',
                    active: true,
                },
                {
                    key: 'richText1',
                    active: false,
                },
                {
                    key: 'richText2',
                    active: false,
                },
                {
                    key: 'richText3',
                    active: false,
                },
                {
                    key: 'richText4',
                    active: false,
                },
                {
                    key: 'richText5',
                    active: false,
                },
                {
                    key: 'richText6',
                    active: false,
                },
                {
                    key: 'richText7',
                    active: false,
                },
                {
                    key: 'richText8',
                    active: false,
                },
                {
                    key: 'richText9',
                    active: false,
                },
                {
                    key: 'richText10',
                    active: false,
                },
            ],
        },
    },
    'crp.mc': {
        type: 'component',
        component: 'RowLayout',
        props: {
            items: ['crp.mc.1', 'crp.mc.tabs'],
            limitToPageWidth: true,
            spacing: 2,
        },
    },
    'default.coursePage': {
        type: 'template',
        name: 'Default Course Landing Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'crp.mc',
        },
    },
    'clp.mc.1': {
        type: 'component',
        component: 'CourseBar',
        props: {
            courseName: '@course.name',
            progress: '@courseProgress', // hardcoded value for now...
        },
    },
    'clp.mc.mcl.outline': {
        type: 'component',
        component: 'SectionsPanel',
        props: {
            sections: '@course.sections',
            lesson: '@lesson',
            selectLessonElement: (lesson) => {
                console.log('Lesson selected', lesson);
            },
        },
    },
    'clp.mc.mcl.content.1': {
        type: 'component',
        component: 'HeaderWithPagination',
        props: {
            labelText: 'LESSON NAME:',
            labelInfo: 'Label Info',
            page: 3,
            totalCount: 10,
            itemsPerPage: 1,
        },
    },
    'clp.mc.mcl.content.2.video': {
        type: 'component',
        component: 'LessonPanel',
        props: {
            lessonElement: '@lesson',
        },
    },
    'clp.mc.mcl.content.2.notes': {
        type: 'component',
        component: 'Notes',
        props: {
            sections: '@course.sections',
        },
    },
    'clp.mc.mcl.content.2': {
        type: 'component',
        component: 'ColumnLayout',
        props: {
            limitToPageWidth: true,
            spacing: 0,
            columns: [
                {
                    id: 'video',
                    xs: 12,
                    md: 9,
                    config: 'clp.mc.mcl.content.2.video',
                },
                {
                    id: 'notes',
                    xs: 12,
                    md: 3,
                    config: 'clp.mc.mcl.content.2.notes',
                },
            ],
        },
    },
    'clp.mc.mcl.content': {
        type: 'component',
        component: 'RowLayout',
        props: {
            items: ['clp.mc.mcl.content.1', 'clp.mc.mcl.content.2'],
        },
    },
    'clp.mc.mcl': {
        type: 'component',
        component: 'ColumnLayout',
        props: {
            spacing: 0,
            columns: [
                {
                    id: 'outline',
                    xs: 12,
                    md: 3,
                    config: 'clp.mc.mcl.outline',
                },
                {
                    id: 'content',
                    xs: 12,
                    md: 9,
                    config: 'clp.mc.mcl.content',
                },
            ],
        },
    },
    'clp.mc.2': {
        type: 'component',
        component: 'StateHolder',
        props: {
            stateName: 'lesson',
            // means child components will get 'course' and 'setCourse' props
            // available to them
            child: 'clp.mc.mcl',
        },
    },
    'clp.mc': {
        type: 'component',
        component: 'Class',
        props: {
            courseID: '@courseID',
            settings: {
                showNotes: true,
                showCourseDesc: true,
                showCourseMaterials: true,
                showProgressBar: true,
                showTranscriptTab: true,
            },
        },
    },
    'clp.copyrightFooter': {
        type: 'component',
        component: 'CopyrightBarWidget',
        props: {
            showCopyrightText: true,
        },
    },
    'default.classPage': {
        type: 'template',
        name: 'Default Course Delivery Page',
        extends: 'default.fullPageLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'clp.mc',
            'ml.footer': 'clp.copyrightFooter',
        },
    },
    'mdp.mc': {
        type: 'component',
        component: 'Microcast',
        props: {
            microcastID: '@microcastID',
            settings: {
                showNotes: true,
                showTranscripts: true,
                showKicker: true,
                showCTA: true,
                showOverview: true,
            },
        },
    },
    'default.microcastPage': {
        type: 'template',
        name: 'Default Microcast Delivery Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'mdp.mc',
        },
    },
    'ip.mc': {
        type: 'component',
        component: 'InstructorDetail',
        props: {
            instructorID: '@instructorID',
        },
    },
    'default.instructorDetail': {
        type: 'template',
        name: 'Default Instructors Delivery Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'ip.mc',
        },
    },
    'member.mc': {
        type: 'component',
        component: 'Member',
        props: {
            memberID: '@memberID',
        },
    },
    'default.memberPage': {
        type: 'template',
        name: 'Default Member Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'member.mc',
        },
    },
    'membership.mc': {
        type: 'component',
        component: 'Membership',
        props: {
            membershipID: '@membershipID',
            modifiers: '@modifiers',
        },
    },
    'default.membershipPage': {
        type: 'template',
        name: 'Default Membership Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'membership.mc',
        },
    },
    'mlp.mc.1': {
        type: 'component',
        component: 'RichTextWidget',
        props: {
            content: {
                html: null,
                slate: [
                    {
                        id: '03gr9',
                        align: 'center',
                        children: [
                            {
                                bold: true,
                                text: '', // Left blank to preserve format
                            },
                        ],
                        type: 'p',
                    },
                ],
            },
            layout: {
                padding: {
                    bottom: '30',
                    right: '',
                    top: '30',
                },
            },
        },
    },
    'membershipLanding.mc': {
        component: 'RowLayout',
        type: 'component',
        props: {
            items: ['mlp.mc.1'],
            limitToPageWidth: true,
            spacing: 2,
        },
    },
    'default.membershipLandingPage': {
        type: 'template',
        name: 'Default Membership Landing Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'membershipLanding.mc',
        },
    },
    'checkout.mc.checkout': {
        component: 'Checkout',
        type: 'component',
        props: {
            checkoutTypes: '@checkoutTypes',
            checkoutIDs: '@checkoutIDs',
        },
    },
    'checkout.mc.message': {
        component: 'RichTextWidget',
        type: 'component',
        props: {
            content: {
                html: null,
                slate: [
                    {
                        id: '03gr9',
                        align: 'center',
                        children: [
                            {
                                bold: true,
                                fontSize: 40,
                                text: '\n\nOne moment please...\n\n\n',
                            },
                        ],
                        type: 'p',
                    },
                ],
            },
            layout: {
                padding: {
                    bottom: '30',
                    right: '',
                    top: '30',
                },
            },
        },
    },
    'checkout.mc': {
        component: 'RowLayout',
        type: 'component',
        props: {
            items: ['checkout.mc.checkout', 'checkout.mc.message'],
            limitToPageWidth: true,
            spacing: 2,
        },
    },
    'default.checkoutPage': {
        type: 'template',
        name: 'Default Checkout Page',
        component: 'RowLayout',
        overrides: {
            'template.ml.mainContent': 'checkout.mc',
        },
    },
    'confirm.mc': {
        component: 'Confirm',
        type: 'component',
    },
    'default.confirmPage': {
        type: 'template',
        name: 'Default Confirm Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'confirm.mc',
        },
    },
    'sp.mc.results': {
        type: 'component',
        component: 'SearchPage',
        props: {
            q: '@q',
            viewAction: '@viewItemAction',
            searchAction: '@searchAction',
        },
    },
    'sp.mc': {
        type: 'component',
        component: 'RowLayout',
        props: {
            items: ['sp.mc.results'],
            limitToPageWidth: true,
            spacing: 2,
        },
    },
    'default.searchPage': {
        type: 'template',
        name: 'Default Search Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'sp.mc',
        },
    },
    'prp.mc.1': {
        type: 'component',
        component: 'ProgramSummary',
        props: {
            programID: '@programID',
            settings: {
                showTitle: true,
                showProgramInfo: true,
                showProgramMedia: true,
                showProgramHeadline: false,
                showProgramDescription: true,
                showDividers: true,
                showInstructor: true,
                showPrice: true,
            },
        },
    },
    'prp.mc': {
        type: 'component',
        component: 'RowLayout',
        props: {
            items: ['prp.mc.1', 'prp.mc.tabs'],
            limitToPageWidth: true,
            spacing: 2,
        },
    },
    'prp.mc.tabs.1': {
        type: 'component',
        component: 'About',
        props: {
            program: '@program',
        },
    },
    'prp.mc.tabs.2': {
        type: 'component',
        component: 'Instructors',
        props: {
            instructors: '@program.instructors',
        },
    },
    'prp.mc.tabs.3': {
        type: 'component',
        component: 'Syllabus',
        props: {
            sections: '@program.sections',
            item: '@program',
            titleTokenKey: 'programOutlineLabel',
        },
    },
    'prp.mc.tabs.4': {
        type: 'component',
        component: 'Reviews',
        props: {
            reviews: '@program.reviews',
        },
    },
    'prp.mc.tabs.5': {
        type: 'component',
        component: 'FAQs',
        props: {
            faqs: '@program.faqs',
        },
    },
    'prp.mc.tabs': {
        type: 'component',
        component: 'ProgramTabs',
        props: {
            programID: '@programID',
            tabSettings: [
                {
                    key: 'about',
                    active: true,
                },
                {
                    key: 'instructors',
                    active: true,
                },
                {
                    key: 'outline',
                    active: true,
                },
                {
                    key: 'richText1',
                    active: false,
                },
                {
                    key: 'richText2',
                    active: false,
                },
                {
                    key: 'richText3',
                    active: false,
                },
                {
                    key: 'richText4',
                    active: false,
                },
                {
                    key: 'richText5',
                    active: false,
                },
                {
                    key: 'richText6',
                    active: false,
                },
                {
                    key: 'richText7',
                    active: false,
                },
                {
                    key: 'richText8',
                    active: false,
                },
                {
                    key: 'richText9',
                    active: false,
                },
                {
                    key: 'richText10',
                    active: false,
                },
            ],
        },
    },
    'default.programPage': {
        type: 'template',
        name: 'Default Program Landing Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'prp.mc',
        },
    },
    'account.mc': {
        type: 'component',
        component: 'MyAccount',
    },
    'default.accountPage': {
        type: 'template',
        name: 'Default Account Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'account.mc',
        },
    },
    'myLearnings.mc': {
        type: 'component',
        component: 'MyLearnings',
    },
    'default.myLearningsPage': {
        type: 'template',
        name: 'Default My Learnings Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'myLearnings.mc',
        },
    },
    'myMeetings.mc': {
        type: 'component',
        component: 'MyMeetings',
    },
    'default.myMeetingsPage': {
        type: 'template',
        name: 'Default My Meetings Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'myMeetings.mc',
        },
    },
    'learningBoard.board': {
        type: 'component',
        component: 'LearningBoardWidget',
    },
    'learningBoard.mc': {
        component: 'RowLayout',
        type: 'component',
        props: {
            items: ['learningBoard.board'],
            limitToPageWidth: true,
            spacing: 2,
        },
    },
    'default.learningBoardPage': {
        type: 'template',
        name: 'Default Learning Board Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'learningBoard.mc',
        },
    },
    'meeting.mc': {
        type: 'component',
        component: 'MeetingDeliveryWidget',
        props: {
            limitToPageWidth: true,
            meetingKey: '@meetingKey',
        },
    },
    'default.meetingPage': {
        type: 'template',
        name: 'Default Meeting Delivery Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'meeting.mc',
        },
    },
    'asset.mc': {
        type: 'component',
        component: 'AssetWidget',
        props: {
            assetKey: '@assetKey',
        },
    },
    'default.assetPage': {
        type: 'template',
        name: 'Default Asset Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'asset.mc',
        },
    },
    'document.mc': {
        type: 'component',
        component: 'DocumentWidget',
        props: {
            documentKey: '@documentKey',
        },
    },
    'default.documentPage': {
        type: 'template',
        name: 'Default Asset Page',
        extends: 'default.mainLayout',
        component: '',
        overrides: {
            'template.ml.mainContent': 'document.mc',
        },
    },
};
const pageConfigs = Object.entries(configs)
    .reduce((result, [key, config]) => {
    if (config.type === 'template') {
        result[key] = config;
    }
    return result;
}, {});
export default {
    defaults,
    configs,
    pageConfigs,
};
//# sourceMappingURL=portalDefaults.js.map